module.exports = __webpack_public_path__ + "static/img/术后宣教@3x.c1eb2e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/术后宣教@3x.png
// module id = 319
// module chunks = 379 380